module.exports = __webpack_public_path__ + "static/media/Details.a924bcd0.svg";